module.exports = __webpack_public_path__ + "static/media/webIcons-24.24ed55d1.svg";